// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DynamicForm__field--Xbxy4{margin-bottom:20px}.DynamicForm__textarea--olhXe textarea{min-height:80px}`, "",{"version":3,"sources":["webpack://./shared/components/DynamicForm/DynamicForm.scss"],"names":[],"mappings":"AAKA,2BACE,kBAAA,CAGF,uCACE,eAAA","sourcesContent":["@import \"../../../styleVars/colors\";\n\n.root {\n}\n\n.field {\n  margin-bottom: 20px;\n}\n\n.textarea textarea {\n  min-height: 80px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"field": `DynamicForm__field--Xbxy4`,
	"textarea": `DynamicForm__textarea--olhXe`
};
module.exports = ___CSS_LOADER_EXPORT___;
